export enum CampusLocation {
  AUSTRALIA = "Australia",
  MALAYSIA = "Malaysia",
}

export function isCampusLocation(value: unknown): value is CampusLocation {
  return Object.values(CampusLocation).includes(value as CampusLocation);
}
